import React, { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";

export function TraceID({ id }: { id: string }) {
    const [copied, setCopied] = useState(false);

    const copy = () => {
        navigator.clipboard.writeText(id).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className="flex items-center gap-2">
            <span className="text-xs font-medium opacity-60 shrink-0">Trace ID</span>
            <code className="text-xs font-mono truncate flex-1 min-w-0">{id}</code>
            <button
                onClick={copy}
                className="opacity-50 hover:opacity-100 transition-opacity shrink-0"
                title="Copy trace ID"
            >
                {copied
                    ? <CheckIcon sx={{ fontSize: 13 }} className="!text-dark-green" />
                    : <ContentCopyIcon sx={{ fontSize: 13 }} />
                }
            </button>
        </div>
    );
}
